import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// get our fontawesome imports
import { faMoon } from '@fortawesome/free-solid-svg-icons';
import "../styles/headerStyle.css";
import React from 'react';





function Header({ toggleDarkMode, darkMode }) {
  

  return(
    
    <div id='header' className={darkMode ? "dark-mode" : "light-mode"}>
     
      <h1 className="title">
        Where in the World?
      </h1>
      
      <div className="dark" onClick={toggleDarkMode}>
        <FontAwesomeIcon className='Dark-Mode'  icon={faMoon} />
        <p className="dark-text">Dark Mode</p>
      </div>
      
    </div>
    
  );
}
export default Header;
